// extracted by mini-css-extract-plugin
export default {"plainText":"MessageContent_plainText__+134y"};